import React from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {Accordion, Card, Form, Row, Col, Button} from "react-bootstrap";
import style from './Sidebar.module.scss';
import {Input, RadioButton, RadioGroup} from '../../components/index';
import Bookmark from './Bookmark.component';
import * as variables from '../../config/variables';
import { parseQuery } from '../../helper/functions';
import transactionTypes from '../../asset/data/transactionTypes';
import propertyTypes from '../../asset/data/propertyTypes';
import bedroomOptions from '../../asset/data/bedrooms';
import foundationOptions from '../../asset/data/foundation';
import areaOptions from '../../asset/data/area';
import overallPriceOptions from '../../asset/data/overallPrice';
import segmentPriceOptions from '../../asset/data/segmentPrice';
import parkingOptions from '../../asset/data/parkings';
import totalFloorOptions from '../../asset/data/totalFloor';
import floorOptions from '../../asset/data/floor';
import unitsPerFloorOptions from '../../asset/data/unitsPerFloor';
import propertyDirectionOptions from '../../asset/data/propertyDirection';
import * as facilityGroupActions from "../../redux/action/facilityGroup.action";
import * as facilityActions from "../../redux/action/facility.action";
import * as cabinetActions from "../../redux/action/cabinet.action";
import * as flooringActions from "../../redux/action/flooring.action";
import * as propertyActions from "../../redux/action/property.action";
import * as generalActions from "../../redux/action/general.action";
import _ from "lodash";

class Sidebar extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      facilityGroups: [],
      allFacilities: [],
      cabinetOptions: [],
      flooringOptions: [],
      accordionIcons: [0],
      bookmarkModal: false,
      savedSearch: [],
      advisorNameTerm: '',
      propertyCodeTerm: ''
    }
  }

  async componentDidMount() {
    await this.fetchFacilityGroups();
    await this.findFacilitiesByGroup();
    await this.fetchCabinets();
    await this.fetchFloorings();
    this.getSavedSearch();
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (this.props.advisorName !== nextProps.advisorName) {
      this.setState({advisorNameTerm: nextProps.advisorName});
    }
    if (this.props.propertyCode !== nextProps.propertyCode) {
      this.setState({propertyCodeTerm: nextProps.propertyCode});
    }
    return true;
  }

  async fetchFacilityGroups() {
    const response = await this.props.findFacilityGroupsByTitle();
    await this.setState({facilityGroups: response});
  }

  async findFacilitiesByGroup(facilityGroup) {
    const response = await this.props.findFacilitiesByGroup(facilityGroup);
    await this.setState({allFacilities: response});
  }

  addFacility(facility) {
    let { facilities } = this.props;
    facilities = facilities ? facilities.split(',') : [];
    if (facilities.find((item)=> item === facility.id)) {
      facilities = facilities.filter((item)=> item !== facility.id);
    } else {
      facilities.push(facility.id);
    }
    this.props.setFacilities(facilities.join(','));
  }

  async fetchCabinets() {
    const response = await this.props.findCabinets();
    await this.setState({ cabinetOptions: response.map((item) => {
        return { value: item.id, label: item.title }
      })});
  }

  async fetchFloorings() {
    const response = await this.props.findFloorings();
    await this.setState({ flooringOptions: response.map((item) => {
        return { value: item.id, label: item.title }
      })});
  }

  accordionToggle(key) {
    const { accordionIcons } = this.state;
    if (accordionIcons.includes(key)) {
      accordionIcons.splice(accordionIcons.findIndex((item) => item === key), 1);
    } else {
      accordionIcons.push(key);
    }

    this.setState({accordionIcons});
  }

  getSavedSearch() {
    const savedSearch = JSON.parse(localStorage.getItem(variables.BOOKMARK)) || [];
    this.setState({savedSearch})
  }

  setBookmark(show, name) {
    this.setState({bookmarkModal: show});

    if (name) {
      let { savedSearch = [] } = this.state;
      if (!savedSearch.find(s => s.name === name)) {
        const bookmark = {
          name,
          url: window.location.search
        };
        savedSearch.push(bookmark);
        localStorage.setItem(variables.BOOKMARK, JSON.stringify(savedSearch));
        this.setState({savedSearch});
      }
    }
  }

  deleteBookmark(e, item) {
    e.stopPropagation();
    let { savedSearch } = this.state;
    savedSearch = savedSearch.filter(s => s.name !== item.name);
    localStorage.setItem(variables.BOOKMARK, JSON.stringify(savedSearch));
    this.setState({savedSearch});
  }

  setSearch(e, item) {
    this.props.setFilter(parseQuery(item.url));
  }

  setAdvisorNameDebounce = _.debounce(async function(value) {
    this.props.setAdvisorName(value);
  }, 1000);

  setPropertyCodeDebounce = _.debounce(async function(value) {
    this.props.setPropertyCode(value);
  }, 1000);

  render() {
    const { accordionIcons, facilityGroups, allFacilities, cabinetOptions, flooringOptions, bookmarkModal, savedSearch, advisorNameTerm, propertyCodeTerm } = this.state;
    const { filterBar, transactionType, propertyType, bedrooms, bedroomExactly, foundationFrom, foundationTo, areaFrom, areaTo, overallPriceFrom, overallPriceTo, segmentPriceFrom, segmentPriceTo, facilities, parkingSpace, parkingSpaceExactly, totalFloors, propertyFloorFrom, propertyFloorTo, totalUnitsPerFloor, balcony, cabinet, flooring, wareHouse, propertyDirection, picture } = this.props;

    return (
      <div className={`${style.sidebar_container} text-right ${filterBar ? style.active : ''}`}>
        <Bookmark show={bookmarkModal} setShow={(name) => {
          this.setBookmark(false, name);
        }} />
        <div className={`${style.sidebar} text-right d-flex flex-column`}>
          <div className={`${style.header} d-flex align-items-center`}>
            <i className={'icon-close'} onClick={() => {this.props.setFilterBar(false)}}/>
            <span className={'text-right'}>جستجو</span>
            <i className={`icon-bookmark-empty ${style.bookmark}`} onClick={() => {
              this.setBookmark(true)
            }} />
          </div>
          <div className={`${style.body} scroll scroll__default`}>
            <div className={style.propertyCode_contianer}>
              <Input type={'text'} label={'کد ملک'} placeholder={'کد ملک'} value={propertyCodeTerm} onChange={(value) => {
                this.setState({propertyCodeTerm: value});
                this.setPropertyCodeDebounce(value);
              }} />
            </div>
            <div className={style.advisorName_contianer}>
              <Input type={'text'} label={'نام مشاور'} placeholder={'نام مشاور'} value={decodeURI(advisorNameTerm)} onChange={(value) => {
                this.setState({advisorNameTerm: value});
                this.setAdvisorNameDebounce(value);
              }} />
            </div>
            <Accordion defaultActiveKey="0">
              <Card className={`${style.card} ${style.first}`}>

                <Accordion.Toggle as={Card.Header} eventKey="0" className={`d-flex ${style.accordion_title} align-items-center`} onClick={() => {this.accordionToggle(0)}}>
                  <i className={'icon-home-fill'} />
                  <span>نوع معامله و ملک</span>
                  <i className={`${accordionIcons.includes(0) ? 'icon-arrow-up' : 'icon-arrow-down'} `} />
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                  <Card.Body className={`${style.card_body}`} >
                    <Form>
                      <Form.Group>
                        <Form.Control as="select" value={transactionType} className={`custom-select`} onChange={(e) => {this.props.setTransactionType(e.target.value)}}>
                          <option value={''} disabled selected hidden>نوع معامله</option>
                          <option value={''}>همه موارد</option>
                          {
                            transactionTypes.map((tt) => {
                              return <option key={`propertyType-${tt.value}`} value={tt.value}>{tt.label}</option>
                            })
                          }
                        </Form.Control>
                      </Form.Group>
                      <hr/>
                      <Form.Group className={'m-0'}>
                        <Form.Control as="select" value={propertyType} className={`custom-select`} onChange={(e) => {this.props.setPropertyType(e.target.value)}}>
                          <option value={''} disabled selected hidden>نوع ملک</option>
                          <option value={''}>همه موارد</option>
                          {
                            propertyTypes.map((pt) => {
                              return <option key={`propertyType-${pt.value}`} value={pt.value}>{pt.label}</option>
                            })
                          }
                        </Form.Control>
                      </Form.Group>
                    </Form>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>

            <Accordion>
              <Card className={`${style.card}`}>
                <Accordion.Toggle as={Card.Header} eventKey="1" className={`d-flex ${style.accordion_title} align-items-center`} onClick={() => {this.accordionToggle(1)}}>
                  <i className={'icon-beds'} />
                  <span>تعداد خواب</span>
                  <i className={`${accordionIcons.includes(1) ? 'icon-arrow-up' : 'icon-arrow-down'} `} />
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="1">
                  <Card.Body className={`${style.card_body}`} >
                    <Form>
                      <Form.Group controlId="formBedrooms" className={'m-0'}>
                        <RadioGroup options={[{ "value": "", "label": "همه" }, ...bedroomOptions.map(item => { return { "value": item.value, "label": bedroomExactly ? item.label : `+${item.label}` } })]} value={bedrooms} onChange={(value) => {this.props.setBedrooms(value)}} />
                        <Form.Check className={`${style.checkbox} checkbox`}
                                    type="checkbox"
                                    checked={bedroomExactly}
                                    onChange={(e) => {this.props.setBedroomExactly(e.target.checked ? true : '')}}
                                    label="دقیقا مطابقت داشته باشد"
                        />
                      </Form.Group>
                    </Form>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>

            <Accordion>
              <Card className={`${style.card}`}>
                <Accordion.Toggle as={Card.Header} eventKey="2" className={`d-flex ${style.accordion_title} align-items-center`} onClick={() => {this.accordionToggle(2)}}>
                  <i className={'icon-meter'} />
                  <span>متراژ</span>
                  <i className={`${accordionIcons.includes(2) ? 'icon-arrow-up' : 'icon-arrow-down'} `} />
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="2">
                  <Card.Body className={`${style.card_body}`} >
                    <Form>
                      <Form.Group>
                        <Form.Label className={style.facility_label}>زیربنا</Form.Label>
                        <Row className={'no-gutters align-items-center'}>
                          <Col>
                            <Form.Control as="select" value={foundationFrom} className={`custom-select`} onChange={(e) => {this.props.setFoundationFrom(e.target.value)}}>
                              <option value={''} disabled selected hidden>از</option>
                              <option value={''}>همه موارد</option>
                              {
                                foundationOptions.map((pt) => {
                                  return <option key={`foundation-from-${pt.value}`} value={pt.value}>{pt.label}</option>
                                })
                              }
                            </Form.Control>
                          </Col>
                          <Col sm={'1'} />
                          <Col>
                            <Form.Control as="select" value={foundationTo} className={`custom-select`} onChange={(e) => {this.props.setFoundationTo(e.target.value)}}>
                              <option value={''} disabled selected hidden>تا</option>
                              <option value={''}>همه موارد</option>
                              {
                                foundationOptions.map((pt) => {
                                  return <option key={`foundation-to-${pt.value}`} value={pt.value}>{pt.label}</option>
                                })
                              }
                            </Form.Control>
                          </Col>
                        </Row>
                      </Form.Group>
                      <hr/>
                      <Form.Group className={'m-0'}>
                        <Form.Label className={style.facility_label}>زمین</Form.Label>
                        <Row className={'no-gutters align-items-center'}>
                          <Col>
                            <Form.Control as="select" value={areaFrom} className={`custom-select`} onChange={(e) => {this.props.setAreaFrom(e.target.value)}}>
                              <option value={''} disabled selected hidden>از</option>
                              <option value={''}>همه موارد</option>
                              {
                                areaOptions.map((pt) => {
                                  return <option key={`area-from-${pt.value}`} value={pt.value}>{pt.label}</option>
                                })
                              }
                            </Form.Control>
                          </Col>
                          <Col sm={'1'} />
                          <Col>
                            <Form.Control as="select" value={areaTo} className={`custom-select`} onChange={(e) => {this.props.setAreaTo(e.target.value)}}>
                              <option value={''} disabled selected hidden>تا</option>
                              <option value={''}>همه موارد</option>
                              {
                                areaOptions.map((pt) => {
                                  return <option key={`area-to-${pt.value}`} value={pt.value}>{pt.label}</option>
                                })
                              }
                            </Form.Control>
                          </Col>
                        </Row>
                      </Form.Group>
                    </Form>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>

            <Accordion>
              <Card className={`${style.card}`}>
                <Accordion.Toggle as={Card.Header} eventKey="3" className={`d-flex ${style.accordion_title} align-items-center`} onClick={() => {this.accordionToggle(3)}}>
                  <i className={'icon-coin'} />
                  <span>قیمت</span>
                  <i className={`${accordionIcons.includes(3) ? 'icon-arrow-up' : 'icon-arrow-down'} `} />
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="3">
                  <Card.Body className={`${style.card_body}`} >
                    <Form>
                      <Form.Group>
                        <Form.Label className={style.facility_label}>قیمت کل / رهن</Form.Label>
                        <Row className={'no-gutters align-items-center'}>
                          <Col>
                            <Form.Control as="select" value={overallPriceFrom} className={`custom-select`} onChange={(e) => {this.props.setOverallPriceFrom(e.target.value)}}>
                              <option value={''} disabled selected hidden>از</option>
                              <option value={''}>همه موارد</option>
                              {
                                transactionType !== 'RENT' ? (
                                    overallPriceOptions.filter(i => +i.value >= 1000000000).map((pt) => {
                                      return <option key={`overall-price-from-${pt.value}`} value={pt.value}>{pt.label}</option>
                                    })
                                ) : (
                                    overallPriceOptions.filter(i => +i.value <= 3000000000).map((pt) => {
                                      return <option key={`overall-price-from-${pt.value}`} value={pt.value}>{pt.label}</option>
                                    })
                                )
                              }
                            </Form.Control>
                          </Col>
                          <Col sm={'1'}/>
                          <Col>
                            <Form.Control as="select" value={overallPriceTo} className={`custom-select`} onChange={(e) => {this.props.setOverallPriceTo(e.target.value)}}>
                              <option value={''} disabled selected hidden>تا</option>
                              <option value={''}>همه موارد</option>
                              {
                                transactionType !== 'RENT' ? (
                                    overallPriceOptions.filter(i => +i.value >= 1000000000).map((pt) => {
                                      return <option key={`overall-to-from-${pt.value}`} value={pt.value}>{pt.label}</option>
                                    })
                                ) : (
                                    overallPriceOptions.filter(i => +i.value <= 3000000000).map((pt) => {
                                      return <option key={`overall-to-from-${pt.value}`} value={pt.value}>{pt.label}</option>
                                    })
                                )
                              }
                            </Form.Control>
                          </Col>
                        </Row>
                      </Form.Group>
                      <hr/>
                      <Form.Group>
                        <Form.Label className={style.facility_label}>قیمت متری / اجاره</Form.Label>
                        <Row className={'no-gutters align-items-center'}>
                          <Col>
                            <Form.Control as="select" value={segmentPriceFrom} className={`custom-select`} onChange={(e) => {this.props.setSegmentPriceFrom(e.target.value)}}>
                              <option value={''} disabled selected hidden>از</option>
                              <option value={''}>همه موارد</option>
                              {
                                transactionType !== 'RENT' ? (
                                    segmentPriceOptions.filter(i => +i.value >= 10000000).map((pt) => {
                                      return <option key={`segment-price-from-${pt.value}`} value={pt.value}>{pt.label}</option>
                                    })
                                ) : (
                                    segmentPriceOptions.filter(i => +i.value <= 10000000).map((pt) => {
                                      return <option key={`segment-price-from-${pt.value}`} value={pt.value}>{pt.label}</option>
                                    })
                                )
                              }
                            </Form.Control>
                          </Col>
                          <Col sm={'1'} />
                          <Col>
                            <Form.Control as="select" value={segmentPriceTo} className={`custom-select`} onChange={(e) => {this.props.setSegmentPriceTo(e.target.value)}}>
                              <option value={''} disabled selected hidden>تا</option>
                              <option value={''}>همه موارد</option>
                              {
                                transactionType !== 'RENT' ? (
                                    segmentPriceOptions.filter(i => +i.value >= 10000000).map((pt) => {
                                      return <option key={`segment-price-to-${pt.value}`} value={pt.value}>{pt.label}</option>
                                    })
                                ) : (
                                    segmentPriceOptions.filter(i => +i.value <= 10000000).map((pt) => {
                                      return <option key={`segment-price-to-${pt.value}`} value={pt.value}>{pt.label}</option>
                                    })
                                )
                              }
                            </Form.Control>
                          </Col>
                        </Row>
                      </Form.Group>
                    </Form>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>

            <Accordion>
              <Card className={`${style.card}`}>
                <Accordion.Toggle as={Card.Header} eventKey="4" className={`d-flex ${style.accordion_title} align-items-center`} onClick={() => {this.accordionToggle(4)}}>
                  <i className={'icon-lamp'} />
                  <span>امکانات</span>
                  <i className={`${accordionIcons.includes(4) ? 'icon-arrow-up' : 'icon-arrow-down'} `} />
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="4">
                  <Card.Body className={`${style.card_body}`} >
                    <Form>
                      {
                        facilityGroups.map((facilityGroup) => {
                          return (
                              <React.Fragment key={facilityGroup.id}>
                                <Form.Label className={style.facility_label}>{facilityGroup.title}</Form.Label>
                                <div className={'d-flex flex-wrap'}>
                                  {
                                    allFacilities.filter(item => item.facilityGroup.id === facilityGroup.id).map((facility) => {
                                      return (
                                          <RadioButton key={facility.id}
                                                       text={facility.title}
                                                       isChecked={facilities.split(',').find((item) => item === facility.id)}
                                                       className={style.facility}
                                                       onChange={() => {
                                                         this.addFacility(facility);
                                                       }}
                                          />
                                      )
                                    })
                                  }
                                </div>
                              </React.Fragment>
                          )
                        })
                      }
                    </Form>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>

            <Accordion>
              <Card className={`${style.card}`}>
                <Accordion.Toggle as={Card.Header} eventKey="5" className={`d-flex ${style.accordion_title} align-items-center`} onClick={() => {this.accordionToggle(5)}}>
                  <i className={'icon-setting'} />
                  <span>سایر</span>
                  <i className={`${accordionIcons.includes(5) ? 'icon-arrow-up' : 'icon-arrow-down'} `} />
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="5">
                  <Card.Body className={`${style.card_body}`} >
                    <Form>
                      <div className={'d-flex'}>
                        <div className={'pl-2'}>
                          <Form.Group controlId="formTour" className={'m-0'}>
                            <Form.Check className={`${style.checkbox} checkbox p-0`}
                                        type="checkbox"
                                        checked={picture}
                                        onChange={(e) => {this.props.setPicture(e.target.checked ? true : '')}}
                                        label="فقط فایل های عکس دار"
                            />
                          </Form.Group>
                        </div>
                        {/*<div className={'px-2'}>
                          <Form.Group controlId="form3d" className={'m-0'}>
                            <Form.Check className={`${style.checkbox} checkbox p-0`} type="checkbox" label="عکس 3D" />
                          </Form.Group>
                        </div>
                        <div className={'pr-2'}>
                          <Form.Group controlId="formVideo" className={'m-0'}>
                            <Form.Check className={`${style.checkbox} checkbox p-0`} type="checkbox" label="ویدئو" />
                          </Form.Group>
                        </div>*/}
                      </div>
                      <hr/>
                      <Form.Group controlId="formParking" className={'mt-3'}>
                        <Form.Label className={style.facility_label}>تعداد پارکینگ</Form.Label>
                        <RadioGroup options={[{ "value": "", "label": "همه" }, ...parkingOptions.map(item => { return { "value": item.value, "label": parkingSpaceExactly ? item.label : `+${item.label}` } })]} value={parkingSpace} onChange={(value) => {this.props.setParkingSpace(value)}} />
                        <Form.Check className={`${style.checkbox} checkbox`}
                                    type="checkbox"
                                    checked={parkingSpaceExactly}
                                    onChange={(e) => {this.props.setParkingSpaceExactly(e.target.checked ? true : '')}}
                                    label="دقیقا مطابقت داشته باشد"
                        />
                      </Form.Group>
                      <hr/>
                      <Form.Control as="select" value={totalFloors} className={`custom-select`} onChange={(e) => {
                        if (e.target.value === '6') {
                          this.props.setTotalFloorsExactly('');
                        } else {
                          this.props.setTotalFloorsExactly(true);
                        }
                        this.props.setTotalFloors(e.target.value);

                      }}>
                        <option value={''} disabled selected hidden>تعداد طبقات</option>
                        <option value={''}>همه موارد</option>
                        {
                          totalFloorOptions.map((tt) => {
                            return <option key={`total-floor-${tt.value}`} value={tt.value}>{tt.label}</option>
                          })
                        }
                      </Form.Control>
                      <hr/>
                      <Form.Group>
                        <Form.Label className={style.facility_label}>طبقه</Form.Label>
                        <Row className={'no-gutters align-items-center'}>
                          <Col>
                            <Form.Control as="select" value={propertyFloorFrom} className={`custom-select`} onChange={(e) => {this.props.setPropertyFloorFrom(e.target.value)}}>
                              <option value={''} disabled selected hidden>از</option>
                              <option value={''}>همه موارد</option>
                              {
                                floorOptions.map((pt) => {
                                  return <option key={`total-from-from-${pt.value}`} value={pt.value}>{pt.label}</option>
                                })
                              }
                            </Form.Control>
                          </Col>
                          <Col sm={'1'}/>
                          <Col>
                            <Form.Control as="select" value={propertyFloorTo} className={`custom-select`} onChange={(e) => {this.props.setPropertyFloorTo(e.target.value)}}>
                              <option value={''} disabled selected hidden>تا</option>
                              <option value={''}>همه موارد</option>
                              {
                                floorOptions.map((pt) => {
                                  return <option key={`total-from-to-${pt.value}`} value={pt.value}>{pt.label}</option>
                                })
                              }
                            </Form.Control>
                          </Col>
                        </Row>
                      </Form.Group>
                      <hr/>
                      <Form.Group controlId={'formUnitsPerFloorExactly'}>
                        <Form.Label className={style.facility_label}>تعداد واحد در طبقه</Form.Label>
                        <RadioGroup options={[{ "value": "", "label": "همه" }, ...unitsPerFloorOptions.map(item => { return { "value": item.value, "label": item.label } })]} value={totalUnitsPerFloor} onChange={(value) => {this.props.setTotalUnitPerFloors(value)}} />
                      </Form.Group>
                      <hr/>
                      <Row>
                        <Col sm={6}>
                          <Form.Group>
                            <Form.Control as="select" value={balcony} className={`custom-select`} onChange={(e) => {this.props.setBalcony(e.target.value)}}>
                              <option value={''} disabled selected hidden>بالکن</option>
                              <option value={''}>همه موارد</option>
                              <option value={'true'}>دارد</option>
                              <option value={'false'}>ندارد</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group>
                            <Form.Control as="select" value={wareHouse} className={`custom-select`} onChange={(e) => {this.props.setWarehouse(e.target.value)}}>
                              <option value={''} disabled selected hidden>انباری</option>
                              <option value={''}>همه موارد</option>
                              <option value={'true'}>دارد</option>
                              <option value={'false'}>ندارد</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group>
                            <Form.Control as="select" value={propertyDirection} className={`custom-select`} onChange={(e) => {this.props.setPropertyDirection(e.target.value)}}>
                              <option value={''} disabled selected hidden>جهت ملک</option>
                              <option value={''}>همه موارد</option>
                              {
                                propertyDirectionOptions.map((tt) => {
                                  return <option key={`property-direction-${tt.value}`} value={tt.value}>{tt.label}</option>
                                })
                              }
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group>
                            <Form.Control as="select" value={cabinet} className={`custom-select`} onChange={(e) => {this.props.setCabinet(e.target.value)}}>
                              <option value={''} disabled selected hidden>کابینت</option>
                              <option value={''}>همه موارد</option>
                              {
                                cabinetOptions.map((tt) => {
                                  return <option key={`cabinet-${tt.value}`} value={tt.value}>{tt.label}</option>
                                })
                              }
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group>
                            <Form.Control as="select" value={flooring} className={`custom-select`} onChange={(e) => {this.props.setFlooring(e.target.value)}}>
                              <option value={''} disabled selected hidden>کفپوش</option>
                              <option value={''}>همه موارد</option>
                              {
                                flooringOptions.map((tt) => {
                                  return <option key={`flooring-${tt.value}`} value={tt.value}>{tt.label}</option>
                                })
                              }
                            </Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Form>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>

            <Accordion>
              <Card className={`${style.card}`}>
                <Accordion.Toggle as={Card.Header} eventKey="6" className={`d-flex ${style.accordion_title} align-items-center`} onClick={() => {this.accordionToggle(6)}}>
                  <i className={'icon-setting'} />
                  <span>جستجوهای ذخیره شده</span>
                  <i className={`${accordionIcons.includes(6) ? 'icon-arrow-up' : 'icon-arrow-down'} `} />
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="6">
                  <Card.Body className={`${style.card_body} ${style.search}`} >
                    {
                      savedSearch && savedSearch.length ? (
                          <table className={style.saved_search}>
                            <thead>
                              <tr>
                                <th className={'text-right'}>عنوان</th>
                                <th className={'d-flex align-items-center justify-content-center'}>حذف</th>
                              </tr>
                            </thead>
                            <tbody>
                            {
                              savedSearch.map((item, index) => {
                                return (
                                  <tr onClick={(e) => {this.setSearch(e, item)}}>
                                    <td className={'text-right'}>
                                      {item.name}
                                    </td>
                                    <td className={'d-flex align-items-center justify-content-center'}>
                                      <i className={'icon-close'} onClick={(e) => {this.deleteBookmark(e, item)}} />
                                    </td>
                                  </tr>
                                )
                              })
                            }
                            </tbody>
                          </table>
                      ) : (
                          <div className={`d-flex justify-content-center align-items-center ${style.not_found}`}>
                            جستجویی ذخیره نشده است
                          </div>
                      )
                    }
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>

            <div className={`d-flex justify-content-center align-items-center ${style.button_container}`}>
              <Button variant={'light'} className={`d-flex align-items-center justify-content-between ${style.clear}`} onClick={() => {
                this.props.setFilter({region: this.props.filter.region, from: 0, length: 15});
              }}>
                <span>پاک کردن جستجو</span>
                <i className={'icon-close'} />
              </Button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Button variant={'primary'} className={`d-flex align-items-center justify-content-between ${style.save_search}`} onClick={() => {
                this.setBookmark(true)
              }}>
                <span>ذخیره جستجو</span>
                <i className={'icon-bookmark-empty'} />
              </Button>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

const mapStateToProps = (state) => ({
  filterBar: state.general.filterBar,
  filter: state.property.filter,
  transactionType: state.property.filter.transactionType,
  advisorName: state.property.filter.advisorName,
  propertyCode: state.property.filter.propertyCode,
  propertyType: state.property.filter.propertyType,
  bedrooms: state.property.filter.bedrooms,
  bedroomExactly: state.property.filter.bedroomExactly,
  foundationFrom: state.property.filter.foundationFrom,
  foundationTo: state.property.filter.foundationTo,
  areaFrom: state.property.filter.areaFrom,
  areaTo: state.property.filter.areaTo,
  overallPriceFrom: state.property.filter.overallPriceFrom,
  overallPriceTo: state.property.filter.overallPriceTo,
  segmentPriceFrom: state.property.filter.segmentPriceFrom,
  segmentPriceTo: state.property.filter.segmentPriceTo,
  facilities: state.property.filter.facilities,
  parkingSpace: state.property.filter.parkingSpace,
  parkingSpaceExactly: state.property.filter.parkingSpaceExactly,
  totalFloors: state.property.filter.totalFloors,
  totalFloorsExactly: state.property.filter.totalFloorsExactly,
  propertyFloorFrom: state.property.filter.propertyFloorFrom,
  propertyFloorTo: state.property.filter.propertyFloorTo,
  totalUnitsPerFloor: state.property.filter.totalUnitsPerFloor,
  totalUnitsPerFloorExactly: state.property.filter.totalUnitsPerFloorExactly,
  propertyUnit: state.property.filter.propertyUnit,
  propertyUnitExactly: state.property.filter.propertyUnitExactly,
  balcony: state.property.filter.balcony,
  cabinet: state.property.filter.cabinet,
  flooring: state.property.filter.flooring,
  wareHouse: state.property.filter.wareHouse,
  propertyDirection: state.property.filter.propertyDirection,
  picture: state.property.filter.picture,
});

const mapDispatchToProps = (dispatch) => ({
  setFilterBar: (show) => dispatch(generalActions.setFilterBar(show)),
  setFilter: (filter) => dispatch(propertyActions.setFilter(filter)),
  findFacilityGroupsByTitle: () => dispatch(facilityGroupActions.findFacilityGroupsByTitle()),
  findFacilitiesByGroup: (facilityGroupId) => dispatch(facilityActions.findFacilitiesByGroup(facilityGroupId)),
  findCabinets: () => dispatch(cabinetActions.findCabinets()),
  findFloorings: () => dispatch(flooringActions.findFloorings()),
  setTransactionType: (transactionType) => dispatch(propertyActions.setTransactionType(transactionType)),
  setAdvisorName: (advisorName) => dispatch(propertyActions.setAdvisorName(advisorName)),
  setPropertyCode: (propertyCode) => dispatch(propertyActions.setPropertyCode(propertyCode)),
  setPropertyType: (propertyType) => dispatch(propertyActions.setPropertyType(propertyType)),
  setBedrooms: (bedrooms) =>  dispatch(propertyActions.setBedrooms(bedrooms)),
  setBedroomExactly: (bedroomExactly) =>  dispatch(propertyActions.setBedroomExactly(bedroomExactly)),
  setFoundationFrom: (foundationFrom) =>  dispatch(propertyActions.setFoundationFrom(foundationFrom)),
  setFoundationTo: (foundationTo) =>  dispatch(propertyActions.setFoundationTo(foundationTo)),
  setAreaFrom: (areaFrom) =>  dispatch(propertyActions.setAreaFrom(areaFrom)),
  setAreaTo: (areaTo) =>  dispatch(propertyActions.setAreaTo(areaTo)),
  setOverallPriceFrom: (overallPriceFrom) =>  dispatch(propertyActions.setOverallPriceFrom(overallPriceFrom)),
  setOverallPriceTo: (overallPriceTo) =>  dispatch(propertyActions.setOverallPriceTo(overallPriceTo)),
  setSegmentPriceFrom: (segmentPriceFrom) =>  dispatch(propertyActions.setSegmentPriceFrom(segmentPriceFrom)),
  setSegmentPriceTo: (segmentPriceTo) =>  dispatch(propertyActions.setSegmentPriceTo(segmentPriceTo)),
  setFacilities: (facilities) =>  dispatch(propertyActions.setFacilities(facilities)),
  setParkingSpace: (parkingSpace) =>  dispatch(propertyActions.setParkingSpace(parkingSpace)),
  setParkingSpaceExactly: (parkingSpaceExactly) =>  dispatch(propertyActions.setParkingSpaceExactly(parkingSpaceExactly)),
  setTotalFloors: (totalFloors) =>  dispatch(propertyActions.setTotalFloors(totalFloors)),
  setTotalFloorsExactly: (totalFloorsExactly) =>  dispatch(propertyActions.setTotalFloorsExactly(totalFloorsExactly)),
  setPropertyFloorFrom: (propertyFloorFrom) =>  dispatch(propertyActions.setPropertyFloorFrom(propertyFloorFrom)),
  setPropertyFloorTo: (propertyFloorTo) =>  dispatch(propertyActions.setPropertyFloorTo(propertyFloorTo)),
  setTotalUnitPerFloors: (totalUnitPerFloors) =>  dispatch(propertyActions.setTotalUnitPerFloors(totalUnitPerFloors)),
  setTotalUnitPerFloorsExactly: (totalUnitPerFloorsExactly) =>  dispatch(propertyActions.setTotalUnitPerFloorsExactly(totalUnitPerFloorsExactly)),
  setPropertyUnit: (propertyUnit) =>  dispatch(propertyActions.setPropertyUnit(propertyUnit)),
  setPropertyUnitExactly: (propertyUnitExactly) =>  dispatch(propertyActions.setPropertyUnitExactly(propertyUnitExactly)),
  setBalcony: (balcony) =>  dispatch(propertyActions.setBalcony(balcony)),
  setCabinet: (cabinet) =>  dispatch(propertyActions.setCabinet(cabinet)),
  setFlooring: (flooring) =>  dispatch(propertyActions.setFlooring(flooring)),
  setWarehouse: (warehouse) =>  dispatch(propertyActions.setWarehouse(warehouse)),
  setPropertyDirection: (propertyDirection) =>  dispatch(propertyActions.setPropertyDirection(propertyDirection)),
  setPicture: (picture) =>  dispatch(propertyActions.setPicture(picture)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar));
